export const SET_SELECTED_TENANT       = 'SET_SELECTED_TENANT';
export const SET_USER_TENANTS          = 'SET_AUTH_USER_TENANTS';
export const UPDATE_TENANT_PICTURE     = 'UPDATE_USER_PICTURE';
export const DELETE_TENANT_PICTURE     = 'DELETE_USER_PICTURE';
export const UPDATE_TENANT             = 'UPDATE_TENANT';
